
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }



  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  new WOW().init();

  jQuery(".sp-scroll").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 1,
    scroll: 1,
  });

  new Swiper('.mySwiper', {
    slidesPerView: 'auto',
    spaceBetween: 35,
    loop: true, //循环滚动
    freeMode: true,
    speed: 6500, //匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: true,
    },
    allowTouchMove: false,
  })
  
  new Swiper(".sp-swiper1", {
    autoplay: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: ".sp-pagination",
      clickable: true,
    },
  });

  new Swiper(".sp-swiper-fade", {
    spaceBetween: 10,
    effect: "fade",
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  });

  new Swiper(".sp-swiper-fade1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
    on: {
      slideChange: function (e) {
        e.slides.find(".sp-text").each(function () {
          this.style.animation = "none";
        });
        const spText = e.slides.eq(e.activeIndex).find(".sp-text")[0];
        if (spText) {
          spText.style.animation = "none";

          spText.style.animation = `swiper-up-fade 0.5s ease forwards`;
        }
      },
    },
  });

  new Swiper(".sp-swiper2", {
    autoplay: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: ".sp-pagination",
      clickable: true
    },
  });

  new Swiper(".sp-part5-swiper", {
    spaceBetween: 30,
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 0,
    },
    loop: true,
    centeredSlides: false,
    speed: 6000,
    freeMode: true,
    slidesPerView: "auto"
    // speed: 5000,
    // autoplay: true,
    // autoplay: {
    //   delay: 1,
    //   disableOnInteraction: false,
    // },
    // slideShadows: true,
    // slidesPerView: "auto",
    // spaceBetween: 0,
    // loop: true,
  });


  new Swiper(".sp-swiper0", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      if (document.body.clientWidth <= 1060) {
        let scale = document.body.clientWidth / 1080;
        $("#root").css("zoom", scale);
      } else {
        const scale = document.body.clientWidth / 1920;
        $("#root").css("zoom", scale);
      }

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
              } else {
                const scale = document.body.clientWidth / 1920;
                $("#root").css("zoom", scale);
              }
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            if (dataSrc) {
              image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            }
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();
    
    // 准备图片数组 - 总共8张图片（sp-type有2个选项，sp-qty有4个选项，2*4=8）
    let imgList = [
        "https://cdn.shopify.com/s/files/1/0671/9320/9081/files/20260124-p5.png",
        "https://cdn.shopify.com/s/files/1/0671/9320/9081/files/20260124-p6.png",
        "https://cdn.shopify.com/s/files/1/0671/9320/9081/files/20260124-p7.png",
        "https://cdn.shopify.com/s/files/1/0671/9320/9081/files/20260124-p8.png",

        "https://cdn.shopify.com/s/files/1/0671/9320/9081/files/401-41.png?v=1775037548",
        "https://cdn.shopify.com/s/files/1/0671/9320/9081/files/401-42.png?v=1775037549",
        "https://cdn.shopify.com/s/files/1/0671/9320/9081/files/401-43.png?v=1775037548",
        "https://cdn.shopify.com/s/files/1/0671/9320/9081/files/401-44.png?v=1775037548",
    ];
    // for (let i = 1; i <= 8; i++) {
    //   imgList.push(`https://cdn.shopify.com/s/files/1/0671/9320/9081/files/20260124-p${i}.png`);
    // }
    
    // 预加载所有图片
    preloadImages(imgList);
    
    // 更新主图显示
    function updateMainImage() {
      let qtyIndex = $("#sp-qty .sp-option.active").index();
      let typeIndex = $("#sp-type .sp-option.active").index();
      
      // 计算图片索引：sp-type的index + sp-qty的index * 2
      let imgIndex = qtyIndex + typeIndex * 4;
      console.log(imgIndex);
      
      // 先根据图片索引设置FREE标签位置（立即设置，不等待图片加载）
      adjustFreeLabelByIndex(imgIndex);
      
      // 更新图片
      let $img = $(".sp-img-p");
      $img.attr('src', imgList[imgIndex]);
      
      // 图片加载完成后，再次根据图片实际高度微调位置
      $img.off('load').on('load', function() {
        // 图片加载完成后，再次设置位置确保准确
        adjustFreeLabelByIndex(imgIndex);
        adjustFreeLabelByImageHeight();
      });
      
      // 如果图片已缓存，立即调整位置
      if ($img.length && $img[0].complete && $img[0].naturalWidth > 0) {
        // 使用setTimeout确保DOM已更新
        setTimeout(function() {
          adjustFreeLabelByIndex(imgIndex);
          adjustFreeLabelByImageHeight();
        }, 0);
      }

    }
    
    // 根据图片索引设置FREE标签位置（每张图片可能有不同的最佳位置）
    function adjustFreeLabelByIndex(imgIndex) {
      let $free = $(".sp-img-wrap .free");
      if (!$free.length) return;
      let isPC = window.innerWidth >= 1080;
      let mobilePositionValues = {
        0: { left: 660, top: 415 },
        1: { left: 185, top: 454 },
        2: { left: 668, top: 436 },
        3: { left: 157, top: 477 },
        4: { left: 668, top: 436 },
        5: { left: 170, top: 467 },
        6: { left: 668, top: 436 },
        7: { left: 668, top: 436 }

      };
      let pcPositionValues = {
        0: { left: 500, top: 306 },
        1: { left: 145, top: 348 },
        2: { left: 492, top: 306 },
        3: { left: 123, top: 372 },
        4: { left: 492, top: 306 },
        5: { left: 123, top: 372 },
        6: { left: 492, top: 306 },
        7: { left: 493, top: 329 }
      };
      
      // 根据设备类型选择对应的配置
      let positionValues = isPC ? pcPositionValues : mobilePositionValues;
      let position = positionValues[imgIndex];
      
      // 如果position是null、false或undefined，隐藏FREE标签
      if (!position || position === null || position === false) {
        $free.css('display', 'none');
        return;
      }
      
      // 显示FREE标签
      $free.css('display', 'block');
      
      // 设置位置（使用left和top，不使用bottom）
      // PC端需要保留transform scale来缩小图片
      let transformValue = isPC ? 'scale(0.65)' : 'none';
      
      $free.css({
        'left': position.left + 'px',
        'top': position.top + 'px',
        'bottom': 'auto',  // 清除bottom定位
        'transform': transformValue,
        'transform-origin': isPC ? 'top left' : 'none'
      });
    }
    
    // 根据图片实际高度动态调整FREE标签位置（备用方案）
    function adjustFreeLabelByImageHeight() {
      let $img = $(".sp-img-p");
      let $free = $(".sp-img-wrap .free");
      
      if ($img.length && $free.length) {
        // 获取图片的实际显示高度
        let imgHeight = $img.height();
        let imgWrapHeight = $img.parent('.sp-img-inner').height();
        
        // 如果图片高度较小，FREE标签可以更靠下
        // 如果图片高度较大，FREE标签需要更靠上
        if (imgHeight < imgWrapHeight * 0.7) {
          // 图片较小，FREE标签可以更靠下
          $free.css('bottom', '60px');
        } else {
          // 图片较大，FREE标签保持在默认位置
          $free.css('bottom', '80px');
        }
      }
    }

    // 数量选项点击事件（sp-type）
    $("#sp-type .sp-option").click(function () {
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      updateMainImage();
      changePrice();
    });
    
    // 护目镜选项点击事件（sp-qty）
    $("#sp-qty .sp-option").click(function () {
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      
      updateMainImage();
      changePrice();
    });
    
    // 初始化图片
    // 使用setTimeout确保DOM完全加载后再初始化
    setTimeout(function() {
      updateMainImage();
    }, 100);

    // IOS字体多了间距的处理
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent);

    if (!isAndroid && !isIOS && !isPC) {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

  // 找到所有跳转套餐的锚点链接 - 使用事件委托确保所有链接都能工作
  function handleShoppingLinkClick(event) {
    const link = event.target.closest('a[href="#shopping"]');
    if (!link) return;
    
    event.preventDefault();
    
    const targetElement = document.getElementById("shopping");
    if (targetElement) {
      const offsetTop = targetElement.offsetTop;
      let sptop = document.body.clientWidth <= 1080 ? 50 : 0;
      let zoomValue = parseFloat($("div#root").css("zoom")) || 1;
      const scrollTop = offsetTop * zoomValue - sptop * zoomValue;

      window.scrollTo({
        top: scrollTop,
        behavior: "smooth",
      });
      
      setTimeout(() => {
        if (window.pageYOffset === 0 || Math.abs(window.pageYOffset - scrollTop) > 100) {
          $('html, body').animate({
            scrollTop: scrollTop
          }, 800);
        }
      }, 100);
    }
  }

  // 处理 GUARANTEES 锚点跳转 - 考虑 zoom 缩放
  function handleGuaranteesLinkClick(event) {
    const link = event.target.closest('a[href="#GUARANTEES"]');
    if (!link) return;
    
    event.preventDefault();
    
    const targetElement = document.getElementById("GUARANTEES");
    if (targetElement) {
      const offsetTop = targetElement.offsetTop;
      let sptop = document.body.clientWidth <= 1080 ? 70 : 68;
      let zoomValue = parseFloat($("div#root").css("zoom")) || 1;
      const scrollTop = offsetTop * zoomValue - sptop * zoomValue;

      window.scrollTo({
        top: scrollTop,
        behavior: "smooth",
      });
      
      setTimeout(() => {
        if (window.pageYOffset === 0 || Math.abs(window.pageYOffset - scrollTop) > 100) {
          $('html, body').animate({
            scrollTop: scrollTop
          }, 800);
        }
      }, 100);
    }
  }
  
  // 使用事件委托在document上监听所有点击
  document.addEventListener('click', handleShoppingLinkClick);
  document.addEventListener('click', handleGuaranteesLinkClick);

  let sp_price1 = 16.99;
  let sp_price2 = 31.98;

  function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    return result.toFixed(2);
  }

  let prods = window.product
    function getCur(){
        let opt1 = $('#sp-type div.active').attr('data-val')
        let opt2 = $('#sp-qty div.active').attr('data-val')
        return prods.filter(item=> item.option1 == opt1 && item.option2 == opt2)[0]
    }
    function changePrice(){
        let num = $('#calcNumber').val()
        let price = (getCur().price * num / 100).toFixed(2)
        let compare = (getCur().compare_at_price * num / 100).toFixed(2)
        price = (price + '').replace('.', ',')
        compare = (compare + '').replace('.', ',')
        // console.log(price)
        $('#sp_price1').html(price)
        $('#sp_price2').html(compare)
        let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
        $(".font-off").html(off_font);
    
    }
    $('.sp-btn-style').click(function(){
        let num = $('#calcNumber').val()
        window.location.href = '/cart/' + getCur().id + ':' + num
    })

  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    // $("#sp_price1").html('$' + calcTotal(sp_price1, input.value));
    // $("#sp_price2").html('$' + calcTotal(sp_price2, input.value));
    changePrice()
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    // $("#sp_price1").html('$' + calcTotal(sp_price1, input.value));
    // $("#sp_price2").html('$' + calcTotal(sp_price2, input.value));
    changePrice()
  });

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span, div");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span/div 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade2 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }

  // 菜单
  $(".sp-menu-btn").click(function (e) {
    $(".sp-menu-mask").show();
  });

  $(".sp-menu-mask").click(function (e) {
    $(".sp-menu-mask").hide();
  });

  function getZoomValue() {
    let zoom = $("div#root").css("zoom");
    return parseFloat(zoom) || 1;
  }

  function handleScroll() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    let zoomValue = getZoomValue();
    let headerHeight = $(".header:visible").height() * zoomValue;
    
    // PC端购物车图标切换
    const pcCartImg = $(".sp-pc .sp-cart .sp-icon");
    
    if (scrollTop > headerHeight) {
      $(".sp-pc .sp-header-top").addClass("sp-fixed");
      // 置顶时使用普通图标
      if (pcCartImg.length && pcCartImg.attr("src") !== "https://cdn.shopify.com/s/files/1/0671/9320/9081/files/20260124-cart-pc.png") {
        pcCartImg.attr("src", "https://cdn.shopify.com/s/files/1/0671/9320/9081/files/20260124-cart-pc.png");
      }
    } else {
      $(".sp-pc .sp-header-top").removeClass("sp-fixed");
      // 未置顶时使用白色图标
      if (pcCartImg.length && pcCartImg.attr("src") !== "https://cdn.shopify.com/s/files/1/0671/9320/9081/files/20260124-cart-white-pc.png") {
        pcCartImg.attr("src", "https://cdn.shopify.com/s/files/1/0671/9320/9081/files/20260124-cart-white-pc.png");
      }
    }
  }

  // 初始检查
  handleScroll();

  // 监听多种滚动事件
  window.addEventListener('scroll', handleScroll, true);
  document.addEventListener('scroll', handleScroll, true);

  $(function () {
    // 判断是否为移动端
    function isMobile() {
      return document.body.clientWidth <= 1060;
    }

    // 购物车加购动效
    $(".cart-btn").click(function () {
      $(this).children("img").addClass("on");
      if (isMobile()) {
        $(".sp-mobile .sp-cart .num").show();
        $(".sp-mobile .sp-cart").addClass("on");
        setTimeout(function () {
          $(".sp-mobile .sp-cart").removeClass("on");
        }, 500);
      } else {
        $(".sp-pc .sp-header-top .sp-cart .num").show();
        $(".sp-pc .sp-header-top .sp-cart").addClass("on");
        setTimeout(function () {
          $(".sp-pc .sp-header-top .sp-cart").removeClass("on");
        }, 500);
      }
      setTimeout(function () {
        $(".cart-btn").children("img").removeClass("on");
      }, 500);
    });

    let initNum = 0;

    $(".product-part .cart-btn").click(function () {
    //   let spNum = $("#calcNumber")[0].value;
    //   initNum += Number(spNum);

    //   // 更新购物车数量
    //   if (isMobile()) {
    //     $(".sp-mobile .cardNum").each(function () {
    //       $(this).html(initNum);
    //     });
    //   } else {
    //     $(".sp-pc .cardNum").each(function () {
    //       $(this).html(initNum);
    //     });
    //   }
    //   $(".cardNum").removeClass("sp-gray");

    var data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            // $("#cardNum").html(result.item_count);
            $(".cardNum").each(function () {
                $(this).html(result.item_count);
                $(this).removeClass("sp-gray");

            });
          });
        },
        dataType: "json",
      });

      var imgs = $(".sp-img-p.active");

      imgs.each(function () {
        var $img = $(this);
        var flyer = $img[0].cloneNode(true);
        flyer.classList.add("sp_clone");

        $(".product-part").append(flyer);
        $(flyer).css({
          width: $img[0].width,
          height: $img[0].height,
          background: "#e7e9ef",
          position: "fixed",
          top: $img[0].offsetTop,
          left: $img.offset().left,
          "z-index": 99,
        });

        let finish, targetTop, targetLeft;
        
        if (isMobile()) {
          // 移动端：飞向底部固定按钮中的购物车
          finish = $(".sp-btn-style2.sp-mobile .sp-cart");
          if (finish.length > 0) {
            targetTop = $(".sp-btn-style2")[0].offsetTop;
            targetLeft = $(".sp-btn-style2 .sp-area2")[0].offsetLeft + finish.width() + 20;
          } else {
            targetTop = 0;
            targetLeft = 0;
          }
        } else {
          // PC端：飞向header中的购物车
          finish = $(".sp-pc .sp-cart");
          if (finish.length > 0) {
            targetTop = finish[0].offsetTop;
            targetLeft = finish[0].offsetLeft;
          } else {
            targetTop = 0;
            targetLeft = 0;
          }
        }

        $(flyer).animate(
          {
            top: targetTop,
            left: targetLeft,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      });
    });
  });

  // 问答
  $(".q-row").click(function () {
    $(this).parent().toggleClass("sp-show");
  });

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName("sp-fade-box");
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll(".sp-ani");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`;
              span.style.animationDelay = `${index * 0.5 + 0.5}s`;
            });

            observerAni.unobserve(gradually2);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually2);
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`;
              span.style.animationDelay = `${index * 0.3 + 1}s`;
            });

            observerAni.unobserve(gradually3);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually3);
  }
});
